import { render, staticRenderFns } from "./ChannelUsers.html?vue&type=template&id=36100c2e&scoped=true&"
import script from "./ChannelUsers.js?vue&type=script&lang=js&"
export * from "./ChannelUsers.js?vue&type=script&lang=js&"
import style0 from "./ChannelUsers.scss?vue&type=style&index=0&id=36100c2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36100c2e",
  null
  
)

export default component.exports